import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { updateShippingAddress } from '../../../store/actions/modal';

import '../../../styles/generic/_form.scss';
import '../../form-elements/form-elements.scss';

class Form extends React.Component {
	constructor(props) {
		super();

		const {
			formModalData,
			shipping
		} = props;

		const data = JSON.parse(formModalData);
		const { formModal } = data;

		this.state = {
			name: shipping.name || '',
			company: shipping.company || '',
			address1: shipping.address1 || '',
			addressLine1Error: '',
			address2: shipping.address2 || '',
			currentCity: shipping.city || '',
			cityError: '',
			email: shipping.email || '',
			emailError: '',
			phone: shipping.phone || '',
			phoneError: '',
			zipPostal: shipping.zipPostal || '',
			zipOrPostalCodeError: '',
			currentStateProvince: shipping.stateProvince || '',
			currentCountry: shipping.country || '',
			countryError: '',
			accountEmail: shipping.accountEmail || '',
			accountCompany: shipping.accountCompany || '',
			accountPhone: shipping.accountPhone || '',
			accountAddress1: shipping.accountAddress1,
			accountAddress2: shipping.accountAddress2,
			accountCity: shipping.accountCity,
			accountStateProvince: shipping.accountStateProvince,
			accountZipPostal: shipping.accountZipPostal,
			accountCountry: shipping.accountCountry,
			accountName: shipping.accountName,
			formModalData: formModal,
			error: null,
			waiting: false,
			addAddress: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.validate = this.validate.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount = () => {
		const { formModalData } = this.state;

		this.setState({ waiting: true });
		fetch('/customercenter-api/getpreviousaddresses',
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then(response => response.json())
			.then(data => {
				formModalData.previousAddresses = data;
				this.setState({ formModalData: formModalData });
				this.setState({ waiting: false });
			});
	}

	onResponse = (response) => {
		this.setState({ waiting: true });

		// Based on what kind of response is received this is where we add
		// either success or fail functionality
		response
			.then((data) => {
				this.setState({ waiting: false });
				const { success, message } = data;
				if (success) {
					this.showResponseScreen();
				} else {
					this.setState({
						error: message,
					});
				}
			})
			.catch((error) => {
				this.setState({
					waiting: false,
					error,
				});
			});
	}

	async onRequest(payload) {
		try {
			const response = await this.postPayload(payload);
			return response;
		} catch (error) {
			return error;
		}
	}

	postPayload = (payload) => {
		const { formModalData } = this.state;
		const { serviceUrl } = formModalData;

		return fetch(serviceUrl,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(payload),
			}).then((response) => {
				return response.json();
			});
	}

	showResponseScreen = () => {
		const { onRequestClose, dispatch } = this.props;
		const {
			name,
			company,
			address1,
			address2,
			currentCity,
			zipPostal,
			currentStateProvince,
			currentCountry,
			email,
			phone,
			accountEmail,
			accountCompany,
			accountPhone,
			accountAddress1,
			accountAddress2,
			accountCity,
			accountStateProvince,
			accountZipPostal,
			accountCountry,
			accountName,
			formModalData
		} = this.state;

		const shipping = {
			city: currentCity,
			country: currentCountry,
			stateProvince: currentStateProvince,
			name,
			company,
			address1,
			address2,
			zipPostal,
			email,
			phone,
			accountEmail,
			accountCompany,
			accountPhone,
			accountAddress1,
			accountAddress2,
			accountCity,
			accountStateProvince,
			accountZipPostal,
			accountCountry,
			accountName,
			formModalData
		};

		dispatch(updateShippingAddress(shipping));
		onRequestClose();
	}

	validate() {
		const {
			name,
			company,
			address1,
			currentCity,
			zipPostal,
			currentCountry,
			email,
			phone,
			formModalData,
		} = this.state;
		const { fieldErrorMessage } = formModalData;

		const errorMessage = fieldErrorMessage;

		let nameError = '';
		let companyError = '';
		let addressLine1Error = '';
		let cityError = '';
		let zipOrPostalCodeError = '';
		let countryError = '';
		let emailError = '';
		let phoneError = '';

		if (name === '') {
			nameError = errorMessage;
		}

		if (company === '') {
			companyError = errorMessage;
		}

		if (address1 === '') {
			addressLine1Error = errorMessage;
		}

		if (currentCity === '') {
			cityError = errorMessage;
		}

		if (zipPostal === '') {
			zipOrPostalCodeError = errorMessage;
		}

		if (currentCountry === '') {
			countryError = errorMessage;
		}

		if (phone === '') {
			phoneError = errorMessage;
		}

		if (email === '') {
			emailError = errorMessage;
		}

		if (nameError ||
			companyError ||
			addressLine1Error ||
			cityError ||
			zipOrPostalCodeError ||
			countryError ||
			phoneError ||
			emailError) {
			this.setState({
				nameError,
				companyError,
				addressLine1Error,
				cityError,
				zipOrPostalCodeError,
				countryError,
				phoneError,
				emailError,
			});

			return false;
		}

		this.setState({
			nameError: '',
			companyError: '',
			addressLine1Error: '',
			cityError: '',
			zipOrPostalCodeError: '',
			countryError: '',
			phoneError: '',
			emailError: '',
		});

		return true;
	}

	handleChange(event, fieldName) {
		this.setState({ [fieldName]: event.target.value });
	}

	handleSubmit(event) {
		event.preventDefault();
		const isValid = this.validate();

		if (isValid) {
			const {
				name,
				company,
				address1,
				address2,
				currentCity,
				zipPostal,
				currentStateProvince,
				currentCountry,
				phone,
				email,
			} = this.state;

			console.log(name);

			this.onResponse(this.onRequest({
				personName: name,
				companyName: company,
				addressLine1: address1,
				addressLine2: address2,
				city: currentCity,
				zipOrPostalCode: zipPostal,
				stateOrProvince: currentStateProvince,
				country: currentCountry,
				phoneNumber: phone,
				emailAddress: email,
			}));
		}
	}

	clickAddress(address, event, form) {
		event.preventDefault();
		this.setState({
			name: address.FirstName + ' ' + address.LastName,
			email: address.EmailAddress,
			phone: address.PhoneNumber,
			company: address.CompanyName,
			address1: address.Address,
			address2: address.Address2,
			currentCity: address.City,
			zipPostal: address.PostalCode,
			currentStateProvince: address.State,
			currentCountry: address.Country
		}, () => this.handleSubmit(event));
	}

	newAddress = (event) => {
		event.preventDefault();
		this.setState({ addAddress: true });
	}

	deleteAddress(address, event) {
		const {
			formModalData
		} = this.state;

		event.preventDefault();
		fetch('/customercenter-api/removeshippingaddress',
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					addressLine1: address.Address,
					addressLine2: address.Address2,
					phoneNumber: address.PhoneNumber,
					emailAddress: address.EmailAddress,
					city: address.City,
					zipOrPostalCode: address.PostalCode,
					stateOrProvince: address.State,
					country: address.Country,
					companyName: address.CompanyName,
					personName: address.FirstName + ' ' + address.LastName
				})
			});

		var index = formModalData.previousAddresses.indexOf(address);
		if (index > -1) {
			var addressesCopy = formModalData.previousAddresses.slice();
			addressesCopy.splice(index, 1);
			formModalData.previousAddresses = addressesCopy;
			this.setState({ formModalData: formModalData });
			shipping.formModalData = formModalData;
		}
	}

	getPreviousAddress() {
		const {
			formModalData
		} = this.state;
		var previousAddresses = formModalData.previousAddresses;
		return (<form className="form form--elements" onSubmit={this.handleSubmit} ref={(ref) => { this.form = ref; }}>
			<div className="previous-address-container">
				<a href="#" className="previous-address add-new" onClick={(event) => this.newAddress(event)}>Add New</a>
				{previousAddresses.map((value, index) => {
					return <div>
						<a href="#" className="previous-address" onClick={(event) => this.clickAddress(value, event, this.form)}>
							<div className="previous-address-contact">
								<div>{value.CompanyName}</div>
								<div>{value.PhoneNumber}</div>
								<div>{value.EmailAddress}</div>
							</div>
							<div className="previous-address-address">
								<div>{value.FirstName} {value.LastName}</div>
								<div>{value.Address}</div>
								<div>{value.Address2}</div>
								<div>{value.City}, {value.State} {value.PostalCode}</div>
							</div>
						</a>
						<a className="delete-address" href="#" onClick={(event) => this.deleteAddress(value, event)}>Delete Address</a>
					</div>

				})}
			</div>
		</form>);
	}

	getForm = () => {
		const {
			name,
			company,
			nameError,
			companyError,
			address1,
			addressLine1Error,
			address2,
			currentCity,
			cityError,
			zipPostal,
			zipOrPostalCodeError,
			currentStateProvince,
			currentCountry,
			countryError,
			formModalData,
			error,
			waiting,
			phone,
			phoneError,
			email,
			emailError,
		} = this.state;

		const {
			personName,
			companyName,
			addressLine1,
			addressLine2,
			city,
			zipOrPostalCode,
			stateOrProvince,
			country,
			saveBtnLabel,
			phoneNumber,
			emailAddress
		} = formModalData;

		const showError = error ? 'form__item__has-error' : null;

		let submitButton = <button type="submit" className="btn btn--primary">{saveBtnLabel}</button>;
		if (waiting) {
			submitButton = (
				<a href="/" className="btn btn--primary flush-right" onClick={(event) => { event.preventDefault(); }}>
					<div className="loading">
						<div className="loading__dots">Loading...</div>
					</div>
				</a>
			);
		}

		return (
			<form className="form form--elements" onSubmit={this.handleSubmit}>
				<div className="form__row">
					<span className={`form__item ${nameError ? 'form__item__has-error' : ''}`} aria-label={personName}>
						<label className="form__item__top-label" htmlFor="address-line-1">{personName}</label>
						<input
							type="text"
							name={personName}
							id="address-line-1"
							aria-describedby="address-line-1-message"
							value={name}
							onChange={(event) => { this.handleChange(event, 'name'); }} />
						<p className="form__item__message">
							<span className="form__item__message__error-cross" />
							{nameError}
						</p>
					</span>
				</div>
				<div className="form__row">
					<span className={`form__item ${emailError ? 'form__item__has-error' : ''}`} aria-label={emailAddress}>
						<label className="form__item__top-label" htmlFor="email">{emailAddress}</label>
						<input
							type="text"
							name={emailAddress}
							id="email"
							aria-describedby="email-message"
							value={email}
							onChange={(event) => { this.handleChange(event, 'email'); }} />
						<p className="form__item__message">
							<span className="form__item__message__error-cross" />
							{emailError}
						</p>
					</span>
				</div>
				<div className="form__row">
					<span className={`form__item ${phoneError ? 'form__item__has-error' : ''}`} aria-label={phoneNumber}>
						<label className="form__item__top-label" htmlFor="phone">{phoneNumber}</label>
						<input
							type="text"
							name={phoneNumber}
							id="phone"
							aria-describedby="phone-message"
							value={phone}
							onChange={(event) => { this.handleChange(event, 'phone'); }} />
						<p className="form__item__message">
							<span className="form__item__message__error-cross" />
							{phoneError}
						</p>
					</span>
				</div>
				<div className="form__row">
					<span className={`form__item ${companyError ? 'form__item__has-error' : ''}`} aria-label={companyName}>
						<label className="form__item__top-label" htmlFor="address-line-1">{companyName}</label>
						<input
							type="text"
							name={companyName}
							id="address-line-1"
							aria-describedby="address-line-1-message"
							value={company}
							onChange={(event) => { this.handleChange(event, 'company'); }} />
						<p className="form__item__message">
							<span className="form__item__message__error-cross" />
							{companyError}
						</p>
					</span>
				</div>
				<div className="form__row">
					<span className={`form__item ${addressLine1Error ? 'form__item__has-error' : ''}`} aria-label={addressLine1}>
						<label className="form__item__top-label" htmlFor="address-line-1">{addressLine1
						}</label>
						<input
							type="text"
							name={addressLine1}
							id="address-line-1"
							aria-describedby="address-line-1-message"
							value={address1}
							onChange={(event) => { this.handleChange(event, 'address1'); }} />
						<p className="form__item__message">
							<span className="form__item__message__error-cross" />
							{addressLine1Error}
						</p>
					</span>
				</div>
				<div className="form__row">
					<span className="form__item" aria-label={addressLine2}>
						<label className="form__item__top-label" htmlFor="address-line-2">{addressLine2}</label>
						<input
							type="text"
							name={addressLine2}
							id="address-line-2"
							aria-describedby="address-line-2-message"
							value={address2}
							onChange={(event) => { this.handleChange(event, 'address2'); }} />
					</span>
				</div>
				<div className="form__row form__row--two-column">
					<span className={`form__item ${cityError ? 'form__item__has-error' : ''}`} aria-label={city}>
						<label className="form__item__top-label" htmlFor="city">{city}</label>
						<input
							type="text"
							name={city}
							id="city"
							aria-describedby="city-message"
							value={currentCity}
							onChange={(event) => { this.handleChange(event, 'currentCity'); }} />
						<p className="form__item__message">
							<span className="form__item__message__error-cross" />
							{cityError}
						</p>
					</span>
					<span className={`form__item ${zipOrPostalCodeError ? 'form__item__has-error' : ''}`} aria-label={zipOrPostalCode}>
						<label className="form__item__top-label" htmlFor="zip-code-or-postal-code">{zipOrPostalCode}</label>
						<input
							type="text"
							name={zipOrPostalCode}
							id="zip-code-or-postal-code"
							aria-describedby="zip-code-or-postal-code-message"
							value={zipPostal}
							onChange={(event) => { this.handleChange(event, 'zipPostal'); }} />
						<p className="form__item__message">
							<span className="form__item__message__error-cross" />
							{zipOrPostalCodeError}
						</p>
					</span>
				</div>
				<div className="form__row form__row--two-column">
					<div className="select-group form__item">
						<label className="select-label form__item__top-label" htmlFor="stateOrProvince">{stateOrProvince.label}</label>
						<div className="select-wrapper">
							<select
								className="select"
								name={stateOrProvince.label}
								id="stateOrProvince"
								onChange={(event) => { this.handleChange(event, 'currentStateProvince'); }}
								value={currentStateProvince}>
								<option value="" hidden>{stateOrProvince.selectLabel}</option>
								{stateOrProvince.options.map(({ label, value }) => {
									return <option key={value} value={value}>{label}</option>;
								})}
							</select>
						</div>
					</div>
					<div className={`select-group form__item ${countryError ? 'form__item__has-error' : ''}`}>
						<label className="select-label form__item__top-label" htmlFor="country">{country.label}</label>
						<div className="select-wrapper">
							<select
								className="select"
								name={country.label}
								id="country"
								onChange={(event) => { this.handleChange(event, 'currentCountry'); }}
								value={currentCountry}>
								<option value="" hidden>{country.selectLabel}</option>
								{country.options.map(({ label, value }) => {
									return <option key={value} value={value}>{label}</option>;
								})}
							</select>
							<p className="form__item__message">
								<span className="form__item__message__error-cross" />
								{countryError}
							</p>
						</div>
					</div>
					<p className={['form__item__message', 'B19-form-modal__error', showError].join(' ')}>
						{error}
					</p>
				</div>
				<div className="modal__form__btn-container">
					{submitButton}
				</div>
			</form>
		);
	}

	render() {
		const {
			onCloseClick,
		} = this.props;
		const {
			formModalData,
			addAddress
		} = this.state;

		const {
			formTitle,
		} = formModalData;

		return (
			<section className="modal__form">
				<button type="button" className="modal__close modal__form__close" onClick={onCloseClick} />
				<div className="modal__form__wrapper">
					<h2 className="form__title">{formTitle}</h2>
					{!addAddress && formModalData.previousAddresses.length ? this.getPreviousAddress() : this.getForm()}
				</div>
			</section>
		);
	}
}

Form.defaultProps = {
	onRequestClose: () => { },
	onCloseClick: () => { },
	formModalData: '',
	shipping: {},
	dispatch: () => { },
};

Form.propTypes = {
	onRequestClose: PropTypes.func,
	onCloseClick: PropTypes.func,
	formModalData: PropTypes.string,
	shipping: PropTypes.shape({}),
	dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
	return {
		shipping: state.modal.shippingAddress || {}
	};
};

export default connect(mapStateToProps)(Form);
